<template lang="pug">
grid-container.page-home-about(
  v-if="content.text",
  cols="auto",
  cols-md="50% 50%"
)
  .d-flex.justify-center.align-center.w-100.pa-4.py-sm-8
    .page-home-about-content
      .page-home-about-content-title.mb-6
        .ubuntu {{ content.title }}
      .text--secondary(v-html="content.text")
  img(v-if="!(sm && !xs)", :src="files + content.img", :alt="content.title")
</template>

<script>
const _config = {
  mod: "about",
};

export default {
  computed: {
    content() {
      return this.$rest(_config.mod).item;
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  beforeCreate() {
    this.$rest(_config.mod).get({ save: (state, data) => (state.item = data) });
  },
};
</script>

<style>
.page-home-about-content {
  max-width: 500px;
}

.page-home-about-content-title {
  font-size: 37px;
  line-height: 43px;
}

.page-home-about img {
  width: 100%;
}
@media screen and (max-width: 960px) {
  .page-home-about-content-title {
    font-size: 32px;
    line-height: 34px;
  }
}
</style>